/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";

// Material UI table
import { MaterialReactTable } from "material-react-table";

//Material UI components for rendring menu and others
import { MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";

import GroupMembersHeader from "../GroupMembersHeader/GroupMembersHeader";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import MemberDetailsModal from "../Modals/MemberDetailsModal";
import ChangeRoleModal from "../Modals/ChangeRoleModal";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import AddNewMemberModal from "../Modals/AddNewMemberModal";
import MemberDetailsPopup from "../Popup/MemberDetailsPopup";
import { groupDetailsHeaderLinks } from "helper/GroupHelper/GroupHelper";
import { useTranslation } from "react-i18next";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";

const GroupMembersBody = () => {
  const params = useParams();
  const token = localStorage.getItem("token");
  const { t, i18n } = useTranslation(); //for translation
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  // -------- tabs header object --------------------
  const commonHeaderObject = groupDetailsHeaderLinks(params.id, t);

  // const { screenHeight } = useContext(GlobalProvider);

  const [groupTitle, setgroupTitle] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [memberList, setMemberList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedMemberIds, setSelectedMemberIds] = useState([]);

  const [memberId, setMemberId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [groupDetailsLoading, setGroupDetailsLoading] = useState(false);
  const [isGroupModerator, setIsGroupModerator] = useState(false);
  const [memberStatus, setMemberStatus] = useState({});

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get group details
  const getgroupDetails = async () => {
    try {
      setGroupDetailsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_GROUP_DETAILS +
        `/${params.id}?modulefrom=common`;

      // console.log("url of group details------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response of group details------>", response);

      if (response.status) {
        //assign title
        response.data?.title && setgroupTitle(response.data?.title);

        const isModerator =
          response.data.moderator?.toString() === userInfo._id?.toString() ||
          ["ADMIN", "SUPER_ADMIN"].includes(userInfo.role?.slug);

        setIsGroupModerator(isModerator);
        if (!isModerator) getMemberDetails();
        setGroupDetailsLoading(false);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get details of event member
  const getMemberDetails = async () => {
    try {
      const apiUrl = `${url.API_BASE_URL}${url.API_GET_GROUP_MEMBER_DETAILS_BY_QUERY}?groupid=${params.id}`;
      const response = await getData(apiUrl);
      if (response.status) {
        setMemberStatus({
          id: response.data._id,
          status: response.data.memberstatus,
          modStatus: response.data.moderatorstatus,
          inviteDate: response.data.requestdate,
          joinDate: response.data.joindate,
        });
      }
    } catch (error) {
      console.error("Error fetching member details:", error);
    }
  };

  //function for get all roles
  const getAllRoles = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MODULE_ROLES +
        `?slug=MOD_GROUP`;

      const response = await getData(requestUrl);

      if (response.status) {
        setRoleList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all event members
  const getAllGroupMembers = async () => {
    setRowSelection({});
    setSelectedMemberIds([]);

    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_GROUP_MEMBERS +
        `?group=${params.id}&modulefrom=backend`;

      const response = await getData(requestUrl);

      // console.log(response);
      setIsLoading(false);

      if (response.status) {
        setMessageType("success");
        setMemberList(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  //function for change status
  const deleteMassiveMemberHandler = async () => {
    if (selectedMemberIds.length > 0) {
      const memberListToBeDelete = memberList.filter((item) =>
        selectedMemberIds.includes(item._id)
      );

      try {
        let memberInfo = {
          groupmembers: memberListToBeDelete,
          group: params.id,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_MASSIVE_GROUP_MEMBERS +
          ``;

        const response = await putData(requestURL, memberInfo);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            getAllGroupMembers();
          }, 2000);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }

      setShowAlert(true);
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one member to delete");
      setShowAlert(true);
    }
  };

  useEffect(() => {
    getAllRoles();
  }, []);

  useEffect(() => {
    if (params.id) {
      getAllGroupMembers();
      getgroupDetails();
    }
  }, [params.id]);

  //material table columns array
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Action"),
      Cell: ({ row }) => {
        const isModerator = row.original.rolestring === "Moderator";
        return (
          <button
            className="action_btn_mui"
            {...(isModerator
              ? {}
              : {
                  "data-bs-toggle": "offcanvas",
                  "data-bs-target": "#offcanvasMemberDetails",
                  "aria-controls": "offcanvasMemberDetails",
                })}
            onClick={() => {
              if (!isModerator) {
                setMemberId(row.original._id);
              }
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        );
      },
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: t("Name"),
      Cell: ({ row }) => (
        <div className="title border-bottom-0">
          <div className="profile d-flex align-items-center gap-2">
            <div
              className="avatar rounded-circle overflow-hidden"
              style={{ width: "35px", height: "35px" }}
            >
              <img
                src={
                  row.original.image == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + row.original.image
                }
                alt="member"
                className="w-100 h-100 object-fit-cover object-center"
              />
            </div>
            <div>
              <p className="fs-md fw-semibold mb-0">{row.original.name}</p>
              <Link to="#" className="d-block lh-1">
                {row.original.email}
              </Link>
            </div>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "rolestring",
      header: t("Role"),
    },
    {
      accessorKey: "moderatorstatus",
      header: t("Status"),
      Cell: ({ row }) => (
        <div className="status border-bottom-0">
          <ul className="d-flex flex-wrap gap-3">
            {row.original.moderatorstatus == "" ? (
              <li className="d-flex align-items-center gap-1">
                <span className="d-block fw-semibold"></span>
              </li>
            ) : (
              <li className="d-flex align-items-center gap-1">
                <span
                  className={`d-block material-symbols-outlined icon-fill icon-lg  ${
                    row.original.moderatorstatus == "1"
                      ? "text-success"
                      : row.original.moderatorstatus == "0"
                      ? "text-primary"
                      : "text-gray"
                  }`}
                >
                  check_circle
                </span>
                <span className="d-block fw-semibold">Moderator</span>
              </li>
            )}
            {row.original.memberstatus == "" ? (
              <li className="d-flex align-items-center gap-1">
                <span className="d-block fw-semibold">--</span>
              </li>
            ) : (
              <li className="d-flex align-items-center gap-1">
                <span
                  className={`d-block material-symbols-outlined icon-fill icon-lg  ${
                    row.original.memberstatus == "1"
                      ? "text-success"
                      : row.original.memberstatus == "0"
                      ? "text-gray"
                      : "text-warning"
                  }`}
                >
                  check_circle
                </span>
                <span className="d-block fw-semibold">Member</span>
              </li>
            )}
          </ul>
        </div>
      ),
    },
    {
      accessorKey: "requestdate",
      header: t("Date"),
    },
    {
      accessorKey: "tagstring",
      header: t("Labels"),
      Cell: ({ row }) => (
        <div className="label border-bottom-0">
          {row.original.tagstring != "" && (
            <ul className="d-flex flex-wrap gap-2 fs-xs">
              {row.original.tagstring.split(" , ").map((tag, index) => {
                return (
                  <li
                    key={index}
                    className="px-2 py-1 gradient-light rounded-5"
                  >
                    {tag}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      ),
    },
  ];

  /** Material React Table Column and States */
  const columns = useMemo(
    () => initialTableColumns,
    [memberList, i18n.language]
  );

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    // console.info("rowSelection", rowSelection);
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key] && key !== "0"
    );

    if (selectedIdsArray.length > 0) {
      setSelectedMemberIds(selectedIdsArray);
    } else {
      setSelectedMemberIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // Render condition
  if (
    !["ADMIN", "SUPER_ADMIN"].includes(userInfo.role?.slug) &&
    !moduleAccess.includes("MOD_GROUP")
  ) {
    return <AccessDeniedView />;
  }

  return (
    <div id="content_wrapper">
      <section className="group-details-wrapper bg-white pb-5">
        {/* --- common header --- */}
        {params.id && (
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Members")}
          />
        )}

        <div className="container-fluid px-lg-5 pt-4 pt-md-0">
          {/* ---- search / filter */}
          <GroupMembersHeader
            groupTitle={groupTitle}
            reloadList={getAllGroupMembers}
            deleteMemberHandler={deleteMassiveMemberHandler}
            isGroupModerator={isGroupModerator}
            memberStatus={memberStatus}
          />

          {/* ----- table section ----- */}

          {isLoading ? (
            <LoadingSkeleton />
          ) : groupDetailsLoading ? (
            <LoadingSkeleton />
          ) : isGroupModerator ? (
            <div className="table-wrapper">
              <MaterialReactTable
                columns={columns} // map columns to be displayed with api data,
                data={memberList} // data from api to be displayed
                enableGrouping
                enableRowSelection // enable showing checkbox
                getRowId={(row) => row._id} // map which value to select with row checkbox
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{ rowSelection, columnOrder: initialColumnOrder }} //pass our managed row selection state to the table to use
                defaultColumn={{
                  minSize: 20,
                  maxSize: 300,
                  size: 50, //make columns wider by default
                }}
                muiTableContainerProps={{
                  sx: {
                    maxHeight: "60vh",
                  },
                }}
                enableStickyHeader
              />
            </div>
          ) : (
            <div className="table-wrapper">
              {memberStatus.status === "1" && memberStatus.modStatus === "1" ? (
                <div className="project-members-container mb-4">
                  <h4 className="fs-sm mb-2 fw-semibold">
                    {t("Team Members")}
                  </h4>
                  <div className="row">
                    {memberList.map((member, index) => {
                      return (
                        <div className="col-lg-3 col-sm-6 mb-2" key={index}>
                          <div className="member-box p-3 rounded-5 bg-white d-flex gap-2 align-items-center">
                            <div className="members-pic d-flex align-items-center justify-content-center overflow-hidden body-bg rounded-circle">
                              <img
                                src={
                                  member.image === ""
                                    ? assetImages.defaultUser
                                    : url.SERVER_URL + member.image
                                }
                                alt=""
                                className="h-100 w-100 object-fit-cover"
                              />
                            </div>
                            <div className="members-info">
                              <h3 className="fs-lg fw-semibold text-black mb-0">
                                {member.name}
                              </h3>
                              <h5 className="fs-sm mb-0 text-black">
                                {member.rolestring}
                              </h5>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </section>

      {/* ==== modals and popup section ==== */}
      {/* ---- add label modal --- */}
      <AddLabelModal moduleName="" />

      {/* add new member modal */}
      <AddNewMemberModal
        roleList={roleList}
        afterCloseModalHandler={getAllGroupMembers}
        setShowAlert={setShowAlert}
        setAlertMessage={setAlertMessage}
        setMessageType={setMessageType}
      />

      {/* --- member details popup ---- */}
      <MemberDetailsPopup
        groupId={params.id}
        roleList={roleList}
        memberId={memberId}
        setMemberId={setMemberId}
        afterPopupClose={getAllGroupMembers}
      />

      <DeleteWarningModal
        onCancelDelete={() => {
          setRowSelection({});
          setSelectedMemberIds([]);
        }}
        onDelete={deleteMassiveMemberHandler}
        moduleName={t("Members")}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default GroupMembersBody;
